import React from "react";

import { useIntl } from "react-intl";

import styles from "./Info.module.scss";
import { messages } from "./messages";

type Props = {
  hasSorting?: boolean;
};

const Info: React.FC<Props> = ({ hasSorting }) => {
  const intl = useIntl();

  const points = [intl.formatMessage(messages.point1), intl.formatMessage(messages.point2)];

  if (hasSorting) {
    points.push(intl.formatMessage(messages.point3));
  }

  return (
    <div className={styles.container}>
      <div>{intl.formatMessage(messages.title)}</div>
      <ul className={styles.list}>
        {points.map((point, index) => (
          <li key={index}>{point}</li>
        ))}
      </ul>
    </div>
  );
};

export default Info;
